import './introduction.scss';

export default () => {

};
